import { Enum } from "@/commons/enums/Type";

export class CwvDeviceTypeEnum {
  static DESKTOP = { value: 1, text: "desktop" };
  static MOBILE = { value: 2, text: "mobile" };

  static getByValue(value: number): Enum | undefined {
    if (value === CwvDeviceTypeEnum.DESKTOP.value) {
      return CwvDeviceTypeEnum.DESKTOP;
    }
    if (value === CwvDeviceTypeEnum.MOBILE.value) {
      return CwvDeviceTypeEnum.MOBILE;
    }
    return undefined;
  }

  static getList(): Enum[] {
    return [CwvDeviceTypeEnum.DESKTOP, CwvDeviceTypeEnum.MOBILE];
  }
}
